// extracted by mini-css-extract-plugin
module.exports = {"duplicatedDocumentsWindow":"duplicatedDocumentsWindow__vkkJt","dialogClassName":"dialogClassName__xu7Fx","content":"content__lKBaD","warningTitle":"warningTitle__Osr+i"};